import { render, staticRenderFns } from "./QuizActivity.vue?vue&type=template&id=620136b4&"
import script from "./QuizActivity.vue?vue&type=script&lang=js&"
export * from "./QuizActivity.vue?vue&type=script&lang=js&"
import style0 from "./QuizActivity.vue?vue&type=style&index=0&id=620136b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports